export function createComponent(createDataList,parentNode,callback){
    createDataList.forEach((item,idx)=>{
        var childNode = document.createElement(item.tag)
        if(item.hasOwnProperty("setting")){
            var SettingList = Object.getOwnPropertyNames(item.setting)
            SettingList.forEach(cItem=>{
                childNode[cItem] =  createDataList[idx].setting[cItem]
            })
        }
        if(item.hasOwnProperty("classList")){
            item.classList.forEach(cItem=>{
                childNode.classList.add(cItem)    
            })
        }
        if(item.hasOwnProperty("children")){
            createComponent(item.children,childNode)
        }else if(item.hasOwnProperty("text")){
            childNode.innerHTML=item.text
        }
        parentNode.appendChild(childNode)
    })
    
    callback && callback();
    return parentNode
}
export const changeBackground = function (imageUrl, className) {
    return function () {
      document.querySelector(className).style.backgroundImage =
        "url('" + imageUrl + "')";
    };
  };
  
export  function GetQueryString(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r!=null)return  decodeURI(r[2]); return null;
}
export const getQuery = function(params){
    let dataObject = {}
    if(Array.isArray(params)){
        params.forEach(item=>{
            dataObject[item] =  GetQueryString(item);
        })
    }else{
        dataObject[params] = GetQueryString(params);
    }
    return dataObject
}